import { all} from 'redux-saga/effects'
import watchFetchDataSaga from './fetchdatasaga'

export default function* rootSaga() {
    yield all([watchFetchDataSaga()])
}